import router from '@/router'
import * as api from '../network/api'
const getDefaultState = () => {
    return {
        userSource: '',
        transactionItem: '',
        appType: 'web'
    }
}
const state = getDefaultState()

const mutations = {
    setAppType(state, appType) {
        state.appType = appType
    },
    setUserSource(state, userSource) {
        state.userSource = userSource
    },
    setTransactionItem(state, transactionItem) {
        state.transactionItem = transactionItem
    }
}
function red(text) {
    return '`' + text + '`'
}
function bold(text) {
    return `*${text}*`
}
const actions = {
    checkQuery({ commit }) {
        const { source, mobile } = router.currentRoute.query
        if (source) {
            commit('setUserSource', source)
            this._vm.$query.removeQuery('source')
        }
        if (mobile) {
            commit('setAppType', mobile === 'true' ? 'mobile' : 'web')
            this._vm.$query.removeQuery('mobile')
        }
    },
    async checkBoughtItems({ commit, state, rootState, rootGetters }) {
        if (!state.transactionItem) {
            return
        }
        const lastBoughtItem = rootState.boughtItems.find(
            item => item.uuid == state.transactionItem
        )
        if (!lastBoughtItem) {
            return commit('setTransactionItem', '')
        }
        const products = rootGetters['content/allProducts']
        const boughtProduct = products.find(
            p => p.uuid == state.transactionItem
        )
        if (!boughtProduct) {
            return commit('setTransactionItem', '')
        }
        const { title } = boughtProduct
        try {
            await sendMessage({
                header: 'New transaction!',
                title,
                rootState,
                state
            })
            commit('setTransactionItem', '')
            commit('setUserSource', '')
        } catch (error) {
            console.log(error)
            await sendMessage({
                header: 'Error!',
                title,
                rootState,
                state,
                error
            })
        }
    }
}
const sendMessage = ({ header, title, rootState, state, error }) => {
    const { display, mail } = rootState.user
    const uuid = state.transactionItem
    const message = `${bold(header)}
            Product name: ${red(title ? title : 'None')}
            Product uuid: ${red(uuid ? uuid : 'None')}
            Source: ${red(state.userSource ? state.userSource : 'None')}
            Client: ${red(display)}
            Mail: ${red(mail)}
            ${error ? `Error: ${error}` : ''}`
    const data = {
        url:
            'https://hooks.slack.com/services/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',
        message,
        channel: '#vod-transactions',
        hash: '7d207d4b4d4bee0fff4653ef6d4d50b3ffa5c09a031dcd440d08c190a397d003'
    }
    return api.post('v1/tools/slack', data)
}
const getters = {
    isMobile: state => {
        return state.appType == 'mobile'
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
